import "core-js/modules/es6.array.reduce";
import r from "react";
export default function t(e) {
  return r.Children.toArray(e).reduce(function (e, n) {
    return n.type === r.Fragment ? e.concat(t(n.props.children)) : (e.push(n), e);
  }, []);
}
;